(function () {
  'use strict';

  const statusRotogram = {
        CONFIGURADO: {
          label: 'ce.mapa.common.modal.modalDetalhesRotograma.descricaoControlarVelocidade',
          classe: 'limite-velocidade-icone placa-ponto-referencia limite-velocidade-placa',
          value: 'CONFIGURADO',
          visible: true,
          hasSpeedIcon: true,
          hasAudioIcon: false
        },
        UTILIZA_VELOCIDADE_ANTERIOR: {
          label: 'ce.mapa.common.modal.modalDetalhesRotograma.descricaoUtilizarVelAnterior',
          classe: 'limite-velocidade-icone placa-ponto-referencia manter-velocidade-placa',
          value: 'UTILIZA_VELOCIDADE_ANTERIOR',
          visible: true,
          hasSpeedIcon: false,
          hasAudioIcon: false
        },
        CONTROLA_VELOCIDADE_INTERNA: {
          label: 'ce.mapa.common.modal.modalDetalhesRotograma.descricaoRotogramaInterno',
          classe: 'limite-velocidade-icone placa-ponto-referencia limite-velocidade-placa',
          value: 'CONTROLA_VELOCIDADE_INTERNA',
          visible: false,
          hasSpeedIcon: true,
          hasAudioIcon: false
        },
        NAO_CONTROLA_VELOCIDADE: {
          label: 'ce.mapa.common.modal.modalDetalhesRotograma.descricaoNaoControlarVelocidade',
          classe: 'limite-velocidade-icone placa-ponto-referencia nao-controlar-velocidade-placa',
          value: 'NAO_CONTROLA_VELOCIDADE',
          visible: false,
          hasSpeedIcon: false,
          hasAudioIcon: false
        },
        ONLY_AUDIO: {
          label: 'NA',
          classe: 'audio-rotogram',
          value: 'ONLY_AUDIO',
          visible: false,
          hasSpeedIcon: false,
          hasAudioIcon: true
        },
        ONLY_AUDIO_INTERN: {
          label: 'NA',
          classe: 'audio-rotogram',
          value: 'ONLY_AUDIO_INTERN',
          visible: false,
          hasSpeedIcon: false,
          hasAudioIcon: true
        },
        SPEED_AND_AUDIO: {
          label: 'NA',
          classe: 'limite-velocidade-icone placa-ponto-referencia limite-velocidade-placa rotogram-and-audio',
          value: 'SPEED_AND_AUDIO',
          visible: false,
          hasSpeedIcon: true,
          hasAudioIcon: true
        },
        KEEP_SPEED_AND_AUDIO: {
          label: 'NA',
          classe: 'limite-velocidade-icone placa-ponto-referencia manter-velocidade-placa',
          value: 'KEEP_SPEED_AND_AUDIO',
          visible: false,
          hasSpeedIcon: false,
          hasAudioIcon: true
        },
        INTERN_SPEED_AND_AUDIO: {
          label: 'NA',
          classe: 'limite-velocidade-icone placa-ponto-referencia limite-velocidade-placa',
          value: 'INTERN_SPEED_AND_AUDIO',
          visible: false,
          hasSpeedIcon: true,
          hasAudioIcon: true
        }
      },
      functions = {
        getStatusRotogram: (key) => statusRotogram[key]
      };

  angular
    .module('rotogramaModule')
    .constant('RotogramaComponentStates', {
      INICIAL: 'rotograma-inicial',
      DESTAQUE: 'rotograma-inicial rotograma-destaque',
      ATIVO: 'rotograma-ativo',
      EXCLUSAO: 'rotograma-exclusao'
    })
    .constant('ControleVelocidadeRotograma', Object.assign({}, statusRotogram, functions))
    .constant('PosicoesRotogramas', (() => {
      const TOPO = {
            key: 'TOPO',
            anguloInicial: 0,
            contemAngulo: (angulo) => angulo >= 315 && angulo <= 360 || angulo >= 0 && angulo < 45
          },
          DIREITA = {
            key: 'DIREITA',
            anguloInicial: 90,
            contemAngulo: (angulo) => angulo >= 45 && angulo < 135
          },
          BASE = {
            key: 'BASE',
            anguloInicial: 180,
            contemAngulo: (angulo) => angulo >= 135 && angulo < 225
          },
          ESQUERDA = {
            key: 'ESQUERDA',
            anguloInicial: 270,
            contemAngulo: (angulo) => angulo >= 225 && angulo < 325
          },
          CENTRO = {
            key: 'CENTRO'
          };

      TOPO.ladosAdjacentes = [DIREITA, ESQUERDA];
      DIREITA.ladosAdjacentes = [TOPO, BASE];
      BASE.ladosAdjacentes = [DIREITA, ESQUERDA];
      ESQUERDA.ladosAdjacentes = [TOPO, BASE];

      return {TOPO, DIREITA, BASE, ESQUERDA, CENTRO};
    })());
}());
